/*
 * Ürün kartı hızlı sepete ekle barı — snippets/hp-product-card-quick-add.liquid.
 *
 * Masaüstünde bar sepet ikonunun üzerine gelince CSS ile açılır. Dokunmatik cihazlarda ikona dokununca açılır/kapanır
 * (is-open), dışarıya dokununca ya da ürün sepete eklenince kapanır.
 *
 * Bedene tıklanınca formun varyant alanı o bedenle doldurulur; sepete ekleme ve sepet çekmecesinin açılması temanın
 * product-form bileşeniyle yapılır. Stokta olmayan bedene tıklanınca Holly Palm Product Alert'in "Gelince Haber Ver"
 * penceresi açılır (app kurulu/aktif değilse hiçbir şey olmaz). Eklenemezse (stok sınırı vb.) hata mesajı barda kısa
 * süre gösterilir. Dinleyiciler document'te olduğu için filtreleme, sonsuz kaydırma vb. ile sonradan eklenen kartlarda
 * da çalışır.
 */
(() => {
  if (window.hpProductCardQuickAdd) return;
  window.hpProductCardQuickAdd = true;

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let openPanel = null;

  const setOpen = (panel, open) => {
    panel.classList.toggle('is-open', open);
    panel.querySelector('.hp-quick-add__icon').setAttribute('aria-expanded', String(open));
    openPanel = open ? panel : null;
  };

  document.addEventListener('click', (event) => {
    const panel = event.target.closest?.('.hp-quick-add__panel');
    if (openPanel && openPanel !== panel) setOpen(openPanel, false);

    if (event.target.closest?.('.hp-quick-add__icon')) {
      if (!finePointer.matches) setOpen(panel, !panel.classList.contains('is-open'));
      return;
    }

    const option = event.target.closest?.('.hp-quick-add__option');
    if (!option) return;

    if (option.dataset.variantId) {
      option.form.id.value = option.dataset.variantId;
    } else if (typeof openHollyNotificationStockOutModal === 'function') {
      openHollyNotificationStockOutModal(option);
    }
  });

  document.addEventListener('variant:add', (event) => {
    const panel = event.target.closest?.('.hp-quick-add__panel');
    if (panel && panel === openPanel) setOpen(panel, false);
  });

  document.addEventListener('cart:error', (event) => {
    const panel = event.target.closest?.('.hp-quick-add__panel');
    if (!panel) return;

    panel.querySelector('.hp-quick-add__error').textContent = event.detail.error;
    panel.classList.add('is-error');
    clearTimeout(panel.hpErrorTimeout);
    panel.hpErrorTimeout = setTimeout(() => panel.classList.remove('is-error'), 3000);
  });
})();
